module.exports = "/_next/static/images/overview-left-f257b9dd5eeb42e596e04839ef5bda1f.png";